/**
 * Number should be expressed as a decimal between 0.0 and 1.0
 *
 * @param number
 * @returns {*}
 */
angular.module('clientDashboardApp').filter('percentage', ['$filter', function ($filter) {
  return function (input, decimals, hidePlusSymbol, hideMinusSymbol) {
    const percentage = input * 100
    const operator = (hidePlusSymbol === false && (percentage > 0)) ? '+' : ''

    const percentageWithMinus = operator + $filter('number', 0)(percentage, decimals) + '%';

    return percentageWithMinus.replace("-", hideMinusSymbol === true ? "" : "-")
  };
}]);
